/**
 * intl-latam-ec-portal-documents
 * No description
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CatalogModel } from './catalog';


/**
 * Aplica si isPaymentWithAutomaticDebit es verdadero.
 */
export class FormAutomaticDebitInformationModel { 
    financialEntity?: CatalogModel;
    /**
     * Tipo de cuenta.
     */
    accountType?: string;
    /**
     * Número de cuenta.
     */
    accountNumber?: string;
    /**
     * Titular de la cuenta.
     */
    accountHolder?: string;
    /**
     * Nùmero de identificaciòn.
     */
    numberIdentification?: string;

    numberMonth: any;


    constructor(){
        this.financialEntity= null;
        this.accountType = null;
        this.accountNumber = null;
        this.accountHolder = null;
        this.numberIdentification = null;
        this.numberMonth = null;
    }
}
